import { render } from "./VsTextarea.vue?vue&type=template&id=71670098"
import script from "./VsTextarea.vue?vue&type=script&lang=js"
export * from "./VsTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__